import apiClient from './index'


const getArticleOrderPath = ({ articleType, orderNumber }) => {
  let path = `/article-orders/`
  if (articleType) {
    path += `${articleType}/`
  } else {
    path += 'article/'
  }
  if (orderNumber) {
    path += `${orderNumber}/`
  }
  return path
}

export default {
  // create
  async createArticleOrder(urlParams, data) {
    return await apiClient.post(getArticleOrderPath(urlParams), data)
  },
  // retrieve
  async getArticleOrder(data) {
    return await apiClient.post(`article-orders/article/`, data)
  },
  async getArticleOrderByHash(data) {
    return await apiClient.post(`article-orders/article-edit/`, data)
  },
  // update
  async updateArticleOrder(urlParams, data) {
    return await apiClient.put(getArticleOrderPath(urlParams), data)
  },
  // delete
  async deleteArticleOrder(urlParams) {
    return await apiClient.delete(getArticleOrderPath(urlParams))
  },
}
